module.exports = __webpack_public_path__ + "static/media/mouthSmileLeft.8e84a7c2.obj";